import { translate } from 'App/Internationalization';
import { withGroupService, withThemeService } from 'service-container';
import EditTheme from 'App/shared/EditTheme';
import Loading from 'shared/Loading';
import React from 'react';

/** @typedef {import('App/Admin/Groups/EditGroupTheme/Props').default} Props */
/** @typedef {import('App/Admin/Groups/EditGroupTheme/State').default} State */
/** @typedef {import('shared/ThemeService/Theme').default} Theme */
/** @typedef {import('shared/ThemeService/ThemeColors').default} ThemeColors */

const defaultGroupName = translate('global.group');

/** @extends {React.Component<Props, State>} */
export class EditGroupTheme extends React.Component {
	/** @param {Props} props */
	constructor(props) {
		super(props);

		/** @type {State} */
		this.state = {
			isLoading: true,
			groupName: defaultGroupName,
			groupNotFound: false,
		};

		this.getTheme = this.getTheme.bind(this);
		this.setFavicon = this.setFavicon.bind(this);
		this.setLogo = this.setLogo.bind(this);
		this.setTheme = this.setTheme.bind(this);
	}

	async componentDidMount() {
		await this.getAndSetGroupName(this.props.match.params.groupId);
	}

	/** @param {string} groupId */
	async getAndSetGroupName(groupId) {
		try {
			const group = await this.props.groupService.getGroup(groupId);

			this.setState({
				isLoading: false,
				groupName: group?.name ?? defaultGroupName,
				groupNotFound: group === null,
			});
		} catch (exception) {
			this.setState({
				isLoading: false,
			});
		}
	}

	/** @returns {Promise<Theme>} */
	getTheme() {
		return this.props.themeService.getGroupTheme(
			this.props.match.params.groupId
		);
	}

	/**
	 * @param {File} favicon
	 * @returns {Promise<void>}
	 */
	setFavicon(favicon) {
		return this.props.themeService.setGroupFavicon(
			this.props.match.params.groupId,
			favicon
		);
	}

	/**
	 * @param {File} logo
	 * @returns {Promise<void>}
	 */
	setLogo(logo) {
		return this.props.themeService.setGroupLogo(
			this.props.match.params.groupId,
			logo
		);
	}

	/**
	 * @param {ThemeColors} colors
	 * @returns {Promise<void>}
	 */
	setTheme(colors) {
		return this.props.themeService.setGroupTheme(
			this.props.match.params.groupId,
			colors
		);
	}

	render() {
		if (this.state.isLoading) {
			return <Loading />;
		}

		if (this.state.groupNotFound) {
			return (
				<p>{translate('admin.pages.import_agents.group_not_found')}</p>
			);
		}

		return (
			<EditTheme
				getTheme={this.getTheme}
				heading={translate(
					'global.header.edit_branding',
					this.state.groupName
				)}
				setFavicon={this.setFavicon}
				setLogo={this.setLogo}
				setTheme={this.setTheme}
				userType="administrator"
			/>
		);
	}
}

export default withGroupService(withThemeService(EditGroupTheme));
